import { CartAddEvent } from '@theme/events';
import { showInstantCart, sizeChoices } from './pf-cart-instant.js?v=20261030h';

/**
 * Add to cart for the heated gloves pages (sections/pf-gloves-main.liquid).
 * The form used to post to /cart and reload the whole page; now the line shows in the cart drawer at once
 * (pf-cart-instant) while Shopify adds it in the background, like on the vest pages.
 */
if (!window.pfGlovesCartBound) {
  window.pfGlovesCartBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const host = form instanceof HTMLFormElement ? form.closest('pf-gloves') : null;
    if (!host || !form.querySelector('[data-id]')) return;
    event.preventDefault();
    if (host.adding) return;
    const id = Number(form.querySelector('[data-id]').value);
    const variants = JSON.parse(host.querySelector('[data-variants]')?.textContent || '[]');
    const variant = variants.find((v) => v.id === id);
    if (!variant?.available) return;
    host.adding = true;
    const button = form.querySelector('[data-atc]');
    const error = host.querySelector('[data-error]');
    if (error) error.hidden = true;
    const root = window.Shopify?.routes?.root || '/';
    const drawer = document.querySelector('cart-drawer-component');
    const quantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1);
    let instant = null;
    try {
      if (drawer) {
        const rowTpl = host.querySelector('template[data-pf-instant="row"]');
        const names = (rowTpl?.dataset.optionNames || '').split('|');
        instant = showInstantCart({
          host,
          lines: [{ variantId: variant.id, options: variant.options, quantity, unitPrice: variant.price, compareAt: variant.compare_at_price || 0, sizes: sizeChoices(variants, names, variant) }],
          format: (cents) => (cents / 100).toFixed(2),
        });
        if (!instant) drawer.open?.();
      }
      if (button) button.disabled = true;
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean))];
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity }], ...(sectionIds.length ? { sections: sectionIds, sections_url: location.pathname } : {}) }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Das Hinzufügen war nicht möglich. Bitte versuchen Sie es erneut.');
      const cart = await fetch(`${root}cart.js`).then((r) => r.json());
      host.dispatchEvent(new CartAddEvent(cart, host.id, { source: 'pf-gloves', productId: host.dataset.productId, itemCount: quantity, sections: data.sections }));
      if (!drawer) location.href = `${root}cart`;
    } catch (err) {
      instant?.revert();
      if (error) { error.textContent = err.message; error.hidden = false; }
    } finally {
      instant?.done();
      host.adding = false;
      if (button) button.disabled = !variant.available;
    }
  });
}
